export interface YouTubeEmbedProps {
  videoId: string;
  width?: string;
  height?: string;
  className?: string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
  videoId,
  width = '100%',
  className = '',
}) => {
  return (
    <div
      className={`relative ${className}`}
      style={{
        width,
        paddingBottom: '56.25%',
        height: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        title="YouTube Video"
        src={`https://www.youtube.com/embed/${videoId}?rel=0&loop=1&playlist=${videoId}`}
        style={{
          border: 0,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default YouTubeEmbed;
